<template functional>
  <div
    class="c-player-controls__bar--embedded"
    :class="[ data.staticClass, data.class ]"
  >
    <div class="c-player__btn--fill">
      <ui-player-live-time-shift v-if="parent.isLive"></ui-player-live-time-shift>
      <ui-player-progress-bar v-else></ui-player-progress-bar>
    </div>
    <div class="c-player__control-buttons c-player__control-buttons--embedded">
      <div class="c-player__btn">
        <ui-player-replay></ui-player-replay>
      </div>
      <div class="u-flex u-flex-row u-flex-align-center">
        <div class="c-player__btn">
          <ui-player-volume></ui-player-volume>
        </div>
        <div class="c-player__btn">
          <ui-player-fullscreen-btn></ui-player-fullscreen-btn>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'UiPlayerEmbeddedRecommendation',
  };
</script>
